import fr from './fr.json'
import en from './en.json'

export const LOCALES = ['fr', 'en'] as const
export type Locale = (typeof LOCALES)[number]
export const DEFAULT_LOCALE: Locale = 'fr'
export const resources = { fr: { translation: fr }, en: { translation: en } } as const
export { fr, en }
